import React from "react";
import {
  getSmsConfig,
  updateSmsConfig
} from "adminApi/SmsSettingApi/SmsSetting";
import { validateForm } from "utils/validation";
// Assuming there is no specific rules for just the trigger settings, or we use SmsSettingRules if they exist
// Wait, the validation rules exist in SmsSettingRules. Need to import it if needed. Let's just import it for now.
import { SmsSettingRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import SmsSettingForm from "./Componate/SmsSettingForm";
import fields from "../json/SmsSettingFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { useRoleVerify } from "Common/RoleVerify";

/**
 * SmsSetting Component
 * Manages SMS notification permissions (e.g., booking, check-in, etc.)
 */
const SmsSetting = () => {
  // Check if user has permission to edit settings
  const canUpdate = useRoleVerify("", ["can_edit"]);
  const { SmsTriggerFormData } = fields;

  // Initialize form state with empty values based on JSON field definitions
  const initialValues = SmsTriggerFormData.reduce(
    (acc, field) => ({ ...acc, [field.name]: "0" }),
    {}
  );

  const { values, errors, handleChange, setValues, setErrors } = useFormChange(
    initialValues,
    {} // Passing empty rules object for triggers as they are just switches and optional
  );

  // Fetch all existing permissions on mount
  // Using useFetchFormDataById assuming ID '1' is the global config like in SmsConfig
  const { loading: loadingFetch } = useFetchFormDataById(
    '1',
    SmsTriggerFormData,
    getSmsConfig,
    setValues
  );

  // Hook for handling form submission
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      // Production refinement: Sending clean JSON object instead of FormData
      return await updateSmsConfig({ data: formValues });
    },
    (vals) => {
      // Perform frontend validation before submission
      return {}; // No validation errors for just switches usually
    },
    () => {
      // Success callback
    },
    "SMS triggers updated successfully!"
  );

  return (
    <>
      {/* Show spinner during data fetch or submission */}
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      
      <SmsSettingForm
        fields={SmsTriggerFormData}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="SMS Trigger Settings"
        canUpdate={canUpdate}
      />
    </>
  );
};

export default SmsSetting;
